export const mulberry32 = (seed: number): (() => number) => {
  let value = seed >>> 0;
  return () => {
    value += 0x6d2b79f5;
    let t = value;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

export const gaussian = (random: () => number): number => {
  const u = Math.max(random(), Number.EPSILON);
  const v = Math.max(random(), Number.EPSILON);
  return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
};

export const linspace = (start: number, stop: number, count: number): number[] => {
  if (count <= 1) return [start];
  const step = (stop - start) / (count - 1);
  return Array.from({ length: count }, (_, index) => start + index * step);
};

export const trapezoid = (xs: readonly number[], ys: readonly number[]): number => {
  const count = Math.min(xs.length, ys.length);
  let total = 0;
  for (let index = 1; index < count; index += 1) {
    const dx = (xs[index] ?? 0) - (xs[index - 1] ?? 0);
    total += dx * ((ys[index] ?? 0) + (ys[index - 1] ?? 0)) * 0.5;
  }
  return total;
};

export const mean = (values: readonly number[]): number => values.length
  ? values.reduce((sum, value) => sum + value, 0) / values.length
  : 0;

export const rms = (values: readonly number[]): number => Math.sqrt(mean(values.map((value) => value * value)));

export const clamp = (value: number, minimum: number, maximum: number): number => Math.max(minimum, Math.min(maximum, value));
